 <!-- app-suscription -->
 <div class="card-body">
    <div class="row">

        <div class="column">
            <div class="logo-bank">
                <img src="/assets/images/subscription.png" alt="">
            </div>
            <div class="credit_data">
                <h4 class="tx_tipo"> {{ 'suscription.title' | translate }}
                    <span class="estatus">{{ 'suscription.plan' | translate }} 
          </span>
                    </h4>
                <p class="tc_number"> {{ 'suscription.cost' | translate }} $19.99 </p>
                <span class="verified"> {{ 'suscription.nextBilling' | translate }} 10/04/2025 </span>
            </div>
            <button class="disable">{{ 'suscription.updateButton' | translate }}</button>
        </div>

    </div>
 </div>
